import { render } from "./SwitchConditionalRender.vue?vue&type=template&id=10b46139&scoped=true&ts=true"
import script from "./SwitchConditionalRender.vue?vue&type=script&lang=ts"
export * from "./SwitchConditionalRender.vue?vue&type=script&lang=ts"

import "./SwitchConditionalRender.vue?vue&type=style&index=0&id=10b46139&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b46139"]])

export default __exports__